import { createCrudService } from '@/services/api/createCrudService'

export type ParameterType = 'MONEY' | 'INTEGER' | 'TEXT' | 'BOOLEAN'

export interface Parameter {
  id: string
  key: string
  label: string
  groupName: string | null
  type: ParameterType
  value: string | null
  description: string | null
  formatted?: { value?: string | null }
}

/** Parâmetros globais do sistema (Configurações > Parâmetros). Só o valor é editável. */
export const ParametersService = createCrudService<Parameter>('/settings/parameters', { searchField: 'label' })
